var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 15,
    viewBox: "0 0 11 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.78359 0.671689C5.69531 0.60101 5.5856 0.5625 5.47251 0.5625C5.35943 0.5625 5.24971 0.60101 5.16143 0.671689C4.97727 0.840916 0 4.8526 0 9.02355C0 10.4756 0.576829 11.8682 1.60359 12.895C2.63035 13.9217 4.02294 14.4986 5.475 14.4986C6.92706 14.4986 8.31965 13.9217 9.34641 12.895C10.3732 11.8682 10.95 10.4756 10.95 9.02355C10.95 4.8526 5.97273 0.840916 5.78359 0.671689ZM5.475 13.5031C4.28695 13.5031 3.14756 13.0311 2.30748 12.1911C1.46741 11.351 0.995455 10.2116 0.995455 9.02355C0.995455 5.88787 4.41484 2.64767 5.475 1.71194C6.53516 2.64767 9.95455 5.88787 9.95455 9.02355C9.95455 10.2116 9.48259 11.351 8.64252 12.1911C7.80244 13.0311 6.66305 13.5031 5.475 13.5031Z",
    fill: "#189FAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.47628 11.5176C4.81625 11.5176 4.18326 11.2554 3.71655 10.7887C3.24984 10.322 2.98764 9.689 2.98764 9.02898C2.98764 8.89697 2.9352 8.77037 2.84186 8.67703C2.74852 8.58369 2.62192 8.53125 2.48991 8.53125C2.35791 8.53125 2.23131 8.58369 2.13797 8.67703C2.04463 8.77037 1.99219 8.89697 1.99219 9.02898C1.99219 9.95302 2.35926 10.8392 3.01265 11.4926C3.66605 12.146 4.55224 12.5131 5.47628 12.5131C5.60828 12.5131 5.73488 12.4606 5.82823 12.3673C5.92157 12.2739 5.97401 12.1473 5.97401 12.0153C5.97401 11.8833 5.92157 11.7567 5.82823 11.6634C5.73488 11.5701 5.60828 11.5176 5.47628 11.5176Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlood);
export default __webpack_public_path__ + "static/media/blood.d12f67bd1639b70db3c026d69e603e01.svg";
export { ForwardRef as ReactComponent };